import PT from 'prop-types';

import JeddleMultiChoiceOption from './JeddleMultiChoiceOption';
import PercentageIndicator from 'edrolo/components/common/PercentageIndicator';

import { quizStatsPropType } from './helpers';

const QuizStats = ({ stats }) => {
  const rawPercentCorrect = Number(stats.get('percent_correct'));
  const percentCorrect = Number.isFinite(rawPercentCorrect)
    ? Math.round(rawPercentCorrect)
    : 0;
  const statText = `${percentCorrect}% of people answered this question correctly`;
  return (
    <span>
      <PercentageIndicator
        className="bg-light-green"
        value={percentCorrect}
        showValue={false}
        orientation="horizontal"
      />
      {statText}
    </span>
  );
};

QuizStats.propTypes = {
  stats: quizStatsPropType,
};

const JeddleMultiChoiceResponse = ({
  questionId,
  showResult,
  answers,
  checked,
  stats,
  onChange,
  disabled,
}) => {
  const inputName = questionId ? `jeddle-q-${questionId}` : undefined;

  return (
    <div className="response multiple-choice clearfix">
      <ol className="left">
        {answers.map((answer) => (
          <JeddleMultiChoiceOption
            key={answer.get('id')}
            name={inputName}
            label={answer.get('text')}
            value={answer.get('id')}
            showResult={showResult}
            checked={checked.includes(answer.get('id'))}
            isCorrect={answer.get('is_correct')}
            onChange={onChange}
            disabled={disabled}
          />
        ))}
      </ol>
      <div className="right">{stats ? <QuizStats stats={stats} /> : null}</div>
    </div>
  );
};

JeddleMultiChoiceResponse.propTypes = {
  questionId: PT.oneOfType([PT.number, PT.string]),
  showResult: PT.bool,
  answers: PT.any.isRequired,
  checked: PT.array,
  stats: quizStatsPropType,
  onChange: PT.func.isRequired,
  disabled: PT.bool,
};

JeddleMultiChoiceResponse.defaultProps = {
  checked: [],
  disabled: false,
  showResult: false,
};

export default JeddleMultiChoiceResponse;
